module.exports = function() {
  return new Worker(__webpack_public_path__ + "148abe10aeae52fa2a9c.worker.js");
};